import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    // Roles --------------------
    addMenu(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/shop-menu', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    changeMenuOrdering(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/shop-menu-change-ordering', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateMenu(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/shop-menu/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteMenu(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/shop-menu/${data.id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchMenus(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/shop-menu', { params: data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // -------types --------------
    // categories
    fetchCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/productcategories', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // brands
    fetchBrands(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/product-brands', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
